import { useEffect, useState } from 'react';

import { useScreenManager } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/hooks/use-screen-manager.tsx';

import { useIsJfindOnboardIllustrationRefreshV2 } from '../../hooks/experiment-hooks';
import { type ProjectConfig } from '../../utils/types';
import { JiraOverlayShim } from '../jira-overlay-shim';

import { PROJECT_CONFIG_SESSION_STORAGE_KEY } from './constants';
import { WelcomeModalPageSwitcher } from './page-switcher';

export const TwcPageSwitcher = () => {
	const { nextScreen } = useScreenManager();
	const [projectConfig, setProjectConfig] = useState<ProjectConfig | null>(null);
	const isIllustrationRefresh = useIsJfindOnboardIllustrationRefreshV2();

	useEffect(() => {
		if (!projectConfig) {
			return;
		}
		const projectConfigString = JSON.stringify(projectConfig);
		sessionStorage.setItem(PROJECT_CONFIG_SESSION_STORAGE_KEY, projectConfigString);
	}, [projectConfig]);

	return (
		<JiraOverlayShim removePadding={isIllustrationRefresh}>
			<WelcomeModalPageSwitcher
				setProjectConfig={setProjectConfig}
				onComplete={nextScreen}
				hasFiredProjectCreate={true}
				skipInviteStep={true}
				isIllustrationRefresh={isIllustrationRefresh}
			/>
		</JiraOverlayShim>
	);
};
